module.exports = __webpack_public_path__ + "static/media/surgical.58bf7a5b.jpg";